import React, { useState, useEffect } from 'react'
import {
  Card,
  Col,
  Row,
  FormGroup,
  Form,
  Button,
  ButtonGroup
} from 'react-bootstrap'
//import * as Icon from 'react-feather'
import FeatherIcon from 'feather-icons-react'
//import Select from 'components/atoms/custom/global/input/CustomSelect'
import Select from 'react-select'
//import ThaiDatePicker from 'components/atoms/custom/global/input/ThaiDatePicker'
import ThaiDatePicker from 'designer/component/element/DatePicker/DatePickerCustom'
import DatePickerCustom from 'components/DatePicker/DatePickerCustom'
import CalendarTimePickerCustom from 'designer/component/element/DatePicker/CalendarTimePickerCustom'
//import SearchHN from 'components/organisms/custom/pas/search/SearchHN'
import DesignerModal from 'designer/external/DesignerModal'
import httpClient from 'utility/httpClient.util'
import { normalizeReportDateParameter } from './reportDateParameter.util'
import { DesignProvider } from 'contexts/DesignContext'
import {
  clearHiddenReportParameterValues,
  isReportParameterVisible,
} from './reportParameterCondition.util'
import {
  getReportParameterType,
  normalizeReportParameterValue,
} from './reportParameterValue.util'

const style = { marginTop: '28px', height: '36px', width: '36px' }

export const HeaderArea = ({
  value,
  onSearch,
  onChange,
  locationCode,
  syReportId,
  showPreview,
  showSearch,
  showInput = true,
  loading = false,
  loadingDataSourceIds = []
}) => {
  const [openSearchHN, setOpenSearchHN] = useState(false)
  const [searchAN, setSearchAN] = useState(false)
  const [searchVN, setSearchVN] = useState(false)
  const [openSearchDrug, setOpenSearchDrug] = useState(false)
  const [selectOptions, setSelectOptions] = useState([])
  const [dpOptions, setDpOptions] = useState([])
  const [spcltyOptions, setSpcltyOptions] = useState([])
  const [componentData, setComponentData] = useState({})
  const [modalCode, setModalCode] = useState(false)
  const onOpenModal = (code) => setModalCode(code)
  const [isLoading, setIsLoading] = useState(false);
  const getResponseList = (response) => {
    if (Array.isArray(response?.data?.data)) return response.data.data
    if (Array.isArray(response?.data)) return response.data
    return []
  }

  const fetchOptionList = async (urls) => {
    const endpointList = Array.isArray(urls) ? urls : [urls]

    for (const url of endpointList) {
      try {
        const response = await httpClient.get(url)
        const list = getResponseList(response)
        if (list.length) return list
      } catch (error) {
        console.error('Header option request failed', url, error)
      }
    }

    return []
  }

  useEffect(() => {
    const loadOptions = async () => {
      if (!loading && value && value.length) {
        const wardField = value.find((item, index) => isWardInput(item.title))
        if (wardField) {
          //Search
          const ward = await fetchOptionList(['/core/ward'])
          setSelectOptions(ward.map((item, index) => {
            const wardCode = item.wardCode
            return { label: wardCode + ' - ' + item.name, value: wardCode }
          }))
          console.log('ward', ward)
        }
        const dpField = value.find((item, index) => isDepartmentInput(item.title))
        if (dpField) {
          //Search
          const ward = await fetchOptionList(['/core/place'])
          setDpOptions(ward.map((item, index) => {
            const placeCode = item.placeCode
            return { label: placeCode + ' - ' + item.department, value: placeCode }
          }))
          console.log('ward', ward)
        }
        const spcltyField = value.find((item, index) => isSpcltyInput(item.title))
        if (spcltyField) {
          //Search
          const ward = await fetchOptionList(['/core/specialty'])
          setSpcltyOptions(ward.map((item, index) => {
            const specialtyCode = item.specialtyCode
            return { label: specialtyCode + ' - ' + item.name, value: specialtyCode }
          }))
          console.log('ward', ward)
        }
      }
    }
    loadOptions()
  }, [loading, value])

  const onPreview = () => {
    let newPageUrl = '#/print/report'
    if (locationCode && locationCode != '')
      newPageUrl += '?reportCode=' + locationCode + ''
    else if (syReportId > 0) {
      newPageUrl += '?reportTemplateId=' + syReportId
    }

    const normalizedInputs = clearHiddenReportParameterValues(value)
    const visibleInputs = normalizedInputs.filter((item) =>
      isReportParameterVisible(item, normalizedInputs),
    )
    visibleInputs.forEach((item) => {
      const itemValue = normalizeReportDateParameter(item)
      newPageUrl += '&' + encodeURIComponent(item.field) + '=' +
        encodeURIComponent(itemValue ?? '')
    })
    window.open(newPageUrl, '_blank')
  }
  const updateData = (item, index, updateValue) => {
    const nextValue = clearHiddenReportParameterValues(
      value.map((input, inputIndex) =>
        inputIndex === index ? { ...input, value: updateValue } : input,
      ),
    )
    if (onChange) {
      onChange(index, nextValue)
    }
    return nextValue
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch(value)
    }
  };

  const toggleOpenSearchHn = () => setOpenSearchHN(!openSearchHN)

  const onSelectCallback = (item, index, param, selectFromField = null) => {
    const selectedValue = param?.[selectFromField || item.field] ?? ''
    const nextValue = updateData(item, index, selectedValue)
    const visibleInputs = nextValue.filter((input) =>
      isReportParameterVisible(input, nextValue),
    )
    if (
      showInput && showSearch && !loading && typeof onSearch === 'function' &&
      visibleInputs.length === 1 &&
      isReportParameterVisible(nextValue[index], nextValue) &&
      ['', 'text'].includes(getReportParameterType(item)) &&
      String(selectedValue).trim() !== ''
    ) {
      // Use the selected values directly; parent state may still hold the old HN.
      onSearchClick(nextValue)
    }
  }

  const onCancelCallback = () => {
    console.log('cancel callback success', componentData)
  }

  const applyTemplate = (template, data) => {
    return template.replace(/\$\{(.*?)\}/g, (_, key) => data[key.trim()] || '');
  };

  const handleMenuOpen = async (item, index) => {
    if (item.dropdownData.source === 'api') {
      try {
        setIsLoading(true);
        // Call the API
        const response = (await httpClient.get(item.dropdownData.endpointUrl)).data;

        // Assuming the API returns an array of objects
        const optionsFromApi = response.data.map((data) => ({
          value: data[item.dropdownData.apiDataValue], // Replace with the correct field name
          label: item.dropdownData?.apiDataLabelTemplate ? applyTemplate(item.dropdownData.apiDataLabelTemplate, data) : data[item.dropdownData.apiDataLabel], // Replace with the correct field name
        }));

        item.dropdownData.choices = optionsFromApi;

      } catch (error) {
        console.error('Error fetching API data:', error);
      } finally {
        setIsLoading(false);
      }
    }else if (item.dropdownData.source === 'datasource') {
      try {
        setIsLoading(true);
        

        item.dropdownData.choices = [];

      } catch (error) {
        console.error('Error fetching API data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCheckboxMenuOpen = async (item, index) => {
    if (item.checkboxData.source === 'api') {
      try {
        setIsLoading(true);
        // Call the API
        const response = (await httpClient.get(item.checkboxData.endpointUrl)).data;

        // Assuming the API returns an array of objects
        const optionsFromApi = response.data.map((data) => ({
          value: data[item.checkboxData.apiDataValue], // Replace with the correct field name
          label: item.checkboxData?.apiDataLabelTemplate ? applyTemplate(item.checkboxData.apiDataLabelTemplate, data) : data[item.checkboxData.apiDataLabel], // Replace with the correct field name
        }));

        item.checkboxData.choices = optionsFromApi;

      } catch (error) {
        console.error('Error fetching API data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };


  const getParamDisplayName = (item = {}) =>
    item.displayName || item.aliasName || item.title

  const renderInput = (item, index, props = {}) => {
    return (
      <FormGroup>
        <Form.Label for={item.field} className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <Form.Control
          {...props}
          type="text"
          name={item.field}
          value={item.value}
          autoComplete="off"
          onChange={(e) => updateData(item, index, e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </FormGroup>
    )
  }

  const renderDateInput = (item, index) => {
    return (
      <FormGroup>
        <Form.Label for="value" className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <DatePickerCustom
          disabled={false}
          value={item.value}
          onChange={(item) => {
            //console.log(item.en)
            updateData(item, index, item.value)
          }}
          clearable={true}
        // className="mr-md-0 pr-xl-0"
        />
      </FormGroup>
    )
  }

  const renderDateTimeInput = (item, index) => {
    return (
      <FormGroup>
        <Form.Label htmlFor={item.field} className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <CalendarTimePickerCustom
          id={item.field}
          name={item.field}
          value={item.value}
          onChange={(dateTime) =>
            updateData(
              item,
              index,
              normalizeReportParameterValue({
                ...item,
                value: dateTime?.value || '',
              }),
            )
          }
          formatDisplay="DD/MM/BBBB HH:mm"
          dateFormat="DD/MM/BBBB"
          timeFormat="HH:mm"
          placeholder="DD/MM/BBBB HH:mm"
          calendar="BE"
          ampm={false}
          isClearable
          handleKeyDown={handleKeyDown}
        />
      </FormGroup>
    )
  }

  const renderSelectInput = (item, index, options) => {
    return (
      <FormGroup style={{ width: '100%' }}>
        <Form.Label for={item.field} className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <Select
          type="select"
          placeholder="--กรุณาเลือก--"
          options={options}
          isClearable
          onChange={(e) => {
            if (e?.value) {
              updateData(item, index, e.value)
            } else {
              updateData(item, index, '')
            }
          }}
          value={item.value ? options.find((option) => option.value === item.value) : null}
        />
      </FormGroup>
    )
  }

  const isHnInput = (title) => {
    return /\bhn\b/i.test(title)
  }

  const isAnInput = (title) => {
    return /\ban\b/i.test(title)
  }

  const isVnInput = (title) => {
    return /\bvn\b/i.test(title)
  }

  const isDrugCodeInput = (title) => {
    return title.toLowerCase().indexOf('drugcode') >= 0
  }

  const isChargeItemCodeInput = (title) => {
    return title.toLowerCase().indexOf('itemcode') >= 0
  }

  const isAccountCodeInput = (title) => {
    return title.toLowerCase().indexOf('accountcode') >= 0
  }

  const isChargeCatInput = (title) => {
    return title.toLowerCase().indexOf('chargecat') >= 0
  }

  const isDoctorCodeInput = (title) => {
    return title.toLowerCase().indexOf('doctorcode') >= 0
  }

  const isEmployeeCodeInput = (title) => {
    return title.toLowerCase().indexOf('employeecode') >= 0
  }


  const isWardInput = (title) => {
    return title.toLowerCase().indexOf('ward') >= 0
  }

  const isDepartmentInput = (title) => {
    return title.toLowerCase().indexOf('ห้อง') >= 0 || title.toLowerCase().indexOf('ห้องตรวจ') >= 0
  }

  const isSpcltyInput = (title) => {
    return title.toLowerCase().indexOf('แผนก') >= 0
  }

  const onSelectHn = (data) => {
    let index = value.findIndex(item => item.title.toLowerCase() === 'hn')
    if (index >= 0) {
      updateData(data, index, data.hn)
      const find = value.find(item => item.value === null || item.value === undefined)
      if (!find)
        onSearch(value)
    }
  }

  const onSelectAn = (data) => {
    let index = value.findIndex(item => item.title.toLowerCase() === 'an')
    if (index >= 0) {
      updateData(data, index, data.an)
      onSearch(value)
    }
  }

  const onSelectVn = (data) => {
    let index = value.findIndex(item => item.title.toLowerCase() === 'vn')
    if (index >= 0) {
      updateData(data, index, data.vn)
      onSearch(value)
    }
  }

  const onSelectDrug = (data) => {
    let index = value.findIndex(item => item.title.toLowerCase() === 'drugcode')
    if (index >= 0) {
      updateData(data, index, data.drugCode)
      const find = value.find(item => item.value === null || item.value === undefined)
      if (!find)
        onSearch(value)
    }
  }

  const renderHelpUi2 = (item) => {
    return (
      <Button
        className="px-1"
        outline
        color="primary"
        style={style}
        onClick={() => { }}
      >
        {item.helpIcon ? <i className={item.helpIcon?.iconClass} /> : <i className={'fas fa-info'} />}
      </Button>
    )
  }

  const renderHelpUi = (item, index,selectFromField=null) => {
    return (
      <DesignProvider>
        <DesignerModal
          code={{
            page: item.helpData.code,
          }}
          component={{
            data: componentData,
            setData: setComponentData
          }}
          callback={{
            selectCallback: (e) => { onSelectCallback(item, index, e,selectFromField) },
            cancelCallback: onCancelCallback,
          }}
          buttonProps={{
            component: (
              <Button
                className="px-1"
                outline
                color="primary"
                style={style}
                title={`เลือก${getParamDisplayName(item)}`}
                aria-label={`เลือก${getParamDisplayName(item)}`}
                onClick={() => onOpenModal(item.helpData.code)}
              >
                {item.helpIcon ? <i className={item.helpIcon?.iconClass} /> : <i className={'fas fa-info'} />}
              </Button>
            ),
            state: {
              modal: [modalCode === item.helpData.code ? modalCode : false, setModalCode],
            },
          }}
          modalProps={{ size: 'xl' }}
        />
      </DesignProvider>
    )
  }

  const renderHelpButton = (item, index) => {
    if (item?.paramType === 'text' && item?.helpData) {
      return renderHelpUi(item, index)
    } else if (item?.paramType !== 'text' && isParamUi(item)) {
      return null
    } else {

      return (<>
      {isHnInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-hn'},helpIcon:{iconClass:'fa fa-user'}},index)}
      {isVnInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-vn'},helpIcon:{iconClass:'fa fa-user'}},index)}
      {isAnInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-an'},helpIcon:{iconClass:'fa fa-user'}},index)}
      {isDrugCodeInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-drug'},helpIcon:{iconClass:'fa fa-info'}},index,'itemCode')}
      {isChargeItemCodeInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-charge'},helpIcon:{iconClass:'fa fa-info'}},index)}
      {isAccountCodeInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-account'},helpIcon:{iconClass:'fa fa-info'}},index)}
      {isChargeCatInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-charge-cat'},helpIcon:{iconClass:'fa fa-info'}},index)}
      {isDoctorCodeInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-employee'},helpIcon:{iconClass:'fa fa-user'}},index,'employeeCode')}
      {isEmployeeCodeInput(item.title) && renderHelpUi({...item,helpData:{code:'page-rpt-search-employee'},helpIcon:{iconClass:'fa fa-user'}},index)}
      </>)

      return (
        <>        {isHnInput(item.title) && (
          <Button
            className="px-1"
            outline
            color="primary"
            style={style}
            onClick={() => { setOpenSearchHN(true); setSearchAN(false); setSearchVN(false) }}
          >
            <FeatherIcon
              size="16"
              icon="user"
              className="vx-icon"
            />
          </Button>
        )}
          {isAnInput(item.title) && (
            <Button
              className="px-1"
              outline
              color="primary"
              style={style}
              onClick={() => { setOpenSearchHN(true); setSearchAN(true); setSearchVN(false) }}
            >
              <FeatherIcon
                size="16"
                icon="user"
                className="vx-icon"
              />
            </Button>
          )}
          {isVnInput(item.title) && (
            <Button
              className="px-1"
              outline
              color="primary"
              style={style}
              onClick={() => { setOpenSearchHN(true); setSearchAN(false); setSearchVN(true) }}
            >
              <FeatherIcon
                size="16"
                icon="user"
                className="vx-icon"
              />
            </Button>
          )}
          {isDrugCodeInput(item.title) && (
            <Button
              className="px-1"
              outline
              color="primary"
              style={style}
              onClick={() => { setOpenSearchDrug(true); }}
            >
              <FeatherIcon
                size="16"
                icon="search"
                className="vx-icon"
              />
            </Button>
          )}
        </>
      )
    }
  }

  const renderDropdownUi = (item, index) => {
    return (
      <FormGroup>
        <Form.Label htmlFor={item.field} className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <div style={{ minWidth: '200px' }} className="justify-content-center">
          {item.dropdownData?.source === 'custom' && (
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              style={{ maxWidth: '250px', minWidth: '200px', display: 'inline-flex' }}
              options={item.dropdownData?.choices}
              value={item.dropdownData?.choices && item.dropdownData?.choices.find(option => option.value == item?.value)}
              onChange={async (e) => updateData(item, index, e.value)}
            // components={{ Option: IconOption, SingleValue: CustomSingleValue }}  
            />)}
          {item.dropdownData?.source === 'api' && (
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              style={{ maxWidth: '250px', minWidth: '200px', display: 'inline-flex' }}
              options={item.dropdownData?.choices}
              value={item.dropdownData?.choices && item.dropdownData.choices.find(option => option.value == item?.value)}
              isLoading={loading} // Display loading spinner when fetching
              onMenuOpen={() => handleMenuOpen(item, index)} // Fetch data on dropdown open            
              onChange={async (e) => updateData(item, index, e.value)}
            />)}
          {item.dropdownData?.source === 'datasource' && (
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              style={{ maxWidth: '250px', minWidth: '200px', display: 'inline-flex' }}
              options={item.dropdownData?.choices}
              value={item.dropdownData?.choices && item.dropdownData.choices.find(option => option.value == item?.value)}
              isLoading={loading || loadingDataSourceIds.includes(item.dropdownData?.dataSourceId)}
              //onMenuOpen={() => handleMenuOpen(item, index)} // Fetch data on dropdown open            
              onChange={async (e) => updateData(item, index, e.value)}
            />)}            
        </div>
      </FormGroup>
    )
  }

  const renderCheckboxUi = (item, index) => {
    return (
      <FormGroup>
        <Form.Label htmlFor={item.field} className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <div style={{ minWidth: '400px' }} className="justify-content-center">
          {item.checkboxData?.source === 'custom' && (
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              isMulti
              menuPortalTarget={document.body}
              style={{ maxWidth: '550px', minWidth: '400px', display: 'inline-flex' }}
              options={item.checkboxData?.choices}
              value={item.checkboxData?.choices && item.checkboxData?.choices.find(option => option.value === item?.value)}
              onChange={async (selectedOptions) => {
                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                await updateData(item, index, selectedValues); // Send an array of values
              }}            
            />)}
          {item.checkboxData?.source === 'api' && (
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              isMulti
              menuPortalTarget={document.body}
              style={{ maxWidth: '550px', minWidth: '400px', display: 'inline-flex' }}
              options={item.checkboxData?.choices}
              value={item.checkboxData?.choices && item.checkboxData?.choices.find(option => option.value === item?.value)}
              isLoading={loading} // Display loading spinner when fetching
              onMenuOpen={() => handleCheckboxMenuOpen(item, index)} // Fetch data on dropdown open            
              onChange={async (selectedOptions) => {
                const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                await updateData(item, index, selectedValues); // Send an array of values
              }}
            />)}
        </div>
      </FormGroup>
    )
  }

  const renderBooleanUi = (item, index) => {
    return (
      <FormGroup>
        <Form.Label htmlFor={item.field} className="text-sm-right">
          {getParamDisplayName(item)}
        </Form.Label>
        <ButtonGroup className="mb-2 d-flex justify-content-center">
          <Button
            variant={item.value === '1' ? 'primary' : 'outline-primary'}
            onClick={() => updateData(item, index, '1')}
          >Yes</Button>
          <Button
            variant={item.value === '0' ? 'primary' : 'outline-primary'}
            onClick={() => updateData(item, index, '0')}
          >No</Button>
          <Button
            variant={'link'}
            style={{ color: 'inherit' }}
            onClick={() => updateData(item, index, '')}
          ><i className='fas fa-times' /></Button>
        </ButtonGroup>
      </FormGroup>
    );
  };


  const isParamUi = (item) => {
    const paramType = getReportParameterType(item)
    return paramType && paramType !== 'text'
  }

  const renderParamUi = (item, index) => {
    const paramType = getReportParameterType(item)

    if (paramType === 'date') {
      return renderDateInput(item, index)
    } else if (paramType === 'datetime') {
      return renderDateTimeInput(item, index)
    } else if (paramType === 'boolean') {
      return renderBooleanUi(item, index)
    } else if (paramType === 'dropdown') {
      return renderDropdownUi(item, index)
    } else if (paramType === 'checkbox') {
      return renderCheckboxUi(item, index)      
    } else {
      return renderInput(item, index, { style: { maxWidth: '250px' } })
    }
  }

  const renderInputForm = () => {
    return value.map((item, index) => {
      if (!isReportParameterVisible(item, value)) return null

      return (
        <Col key={item.field || item.title || index} style={{ maxWidth: '450px', display: 'inline-flex' }}>
          {
            isParamUi(item)
              ? renderParamUi(item, index)
              : isWardInput(item.title)
                ? renderSelectInput(item, index, selectOptions)
                : isDepartmentInput(item.title)
                  ? renderSelectInput(item, index, dpOptions)
                  : isSpcltyInput(item.title)
                    ? renderSelectInput(item, index, spcltyOptions)
                    : renderInput(item, index, { style: { maxWidth: '250px' } })}
          {renderHelpButton(item, index)}
        </Col>
      )
    })
  }


  const onSearchClick = (inputs = value) => {
    const newValue = clearHiddenReportParameterValues(inputs).map((item) => ({
      ...item,
      value: normalizeReportDateParameter(item),
    }))
    onSearch(newValue)
  }

  return (
    <>
      <Row>
        {showInput && renderInputForm()}
        {showInput && (
          <FormGroup className="mx-1 col">
            <div className="text-sm-right">&nbsp;</div>
            {showSearch && (
              <Button
                color="primary"
                className='mt-2'
                title="ดึงข้อมูลรายงาน"
                aria-label="ดึงข้อมูลรายงาน"
                onClick={() => onSearchClick()}
              >
                <FeatherIcon
                  size="16"
                  icon="search"
                  className="vx-icon mx-1"
                />
                ดึงข้อมูล
              </Button>
            )}
            {showPreview && (
              <Button
                onClick={() => onPreview()}
                link=""
                className='mt-2'
                title="เปิดหน้าตัวอย่างรายงาน"
                aria-label="เปิดหน้าตัวอย่างรายงาน"
              >
                <FeatherIcon
                  size="16"
                  icon="printer"
                  className="vx-icon mr-2"
                />
                Preview
              </Button>
            )}
            {loading && (<span>กำลังดึงข้อมูล....</span>)}
          </FormGroup>)}
      </Row>
    </>
  )
}
